import { Route, Switch, useRouteMatch } from 'react-router-dom';
import List from './pages/List';

export default function DisplayControlGroup() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <List />
        </Route>
      </Switch>
    </div>
  );
}
